
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Session} from './Session';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {TaxplanIQServices} from "./TaxplanIQServices";
import {PATH, SOURCE_TYPE} from "../constants/Tpiq.constants";

@Injectable({
  providedIn: 'root'
})
export class ExportService extends TaxplanIQServices {

    constructor(http: HttpClient) {
        super(http);
    }

    private handleError(error: HttpErrorResponse) {
        return throwError(error.error);
    }

    getHeaders(): any {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json;charset=UTF-8');
        headers = headers.append('Authorization', 'Bearer ' + Session.getToken());
        const options: any = {
            responseType: 'arraybuffer',
            headers
        };
        return options;
    }

    exportReportIntoFile(url, data): Observable<any>  {
        return this.create(url, data, SOURCE_TYPE.JAVA, this.getHeaders()).pipe(catchError(this.handleError));
    }

    exportTableIntoFile(orgId: any, userId: any, data: any): Observable<any>  {
        const url = this.interpolateUrl(PATH.EXPORT_SERVICE, null, { orgId: orgId, userId: userId});
        return this.create(url, data, SOURCE_TYPE.JAVA, this.getHeaders()).pipe(catchError(this.handleError));
    }
}
